{
  "title": "Guida alle taglie",
  "runsSmallLabel": "Veste piccolo",
  "trueToSizeLabel": "Veste regolare",
  "runsLargeLabel": "Veste grande",
  "confidenceText": "{value}% di sicurezza basato su feedback reali dei clienti",
  "loading": "Caricamento guida alle taglie...",
  "fitCategorySmall": "Probabilmente veste piccolo",
  "fitCategoryTrue": "Veste regolare",
  "fitCategoryLarge": "Probabilmente veste grande",
  "fallbackTruePill": "Probabilmente veste regolare",
  "noDataPill": "Nessun dato disponibile",
  "errorPill": "Temporaneamente non disponibile",
  "recommendationHeadingSmall": "Considera una taglia in più",
  "recommendationHeadingTrue": "Dovrebbe vestire come previsto",
  "recommendationHeadingLarge": "Considera una taglia in meno",
  "fallbackTrueHeading": "Dovrebbe vestire come previsto",
  "fallbackTrueSummary": "Non abbiamo ancora abbastanza feedback dei clienti per questo articolo, quindi questa vista presume una vestibilità regolare.",
  "noDataHeading": "Nessun dato disponibile",
  "noDataSummary": "Non abbiamo ancora abbastanza feedback dei clienti per questo articolo.",
  "errorHeading": "Guida alle taglie non disponibile",
  "errorSummary": "Questa raccomandazione sulla taglia è temporaneamente non disponibile. Riprova più tardi.",
  "fallbackSummarySmall": "Il feedback dei clienti suggerisce che questo articolo potrebbe vestire più piccolo del previsto.",
  "fallbackSummaryTrue": "Il feedback dei clienti suggerisce che questo articolo dovrebbe vestire come previsto.",
  "fallbackSummaryLarge": "Il feedback dei clienti suggerisce che questo articolo potrebbe vestire più grande del previsto."
}